<main [ngClass]="themeService.isDarkMode ? 'darkmode' : ''">
  <app-left-sidebar
    (pendingUpdate)="onPendingUpdate($event)"
    (backlogEventCreated)="processNewEvent($event, 'local')"
    (backlogEventUpdated)="processUpdatedEvent($event, 'local')"
    (moveToBacklogCompleted)="processUpdatedEvent($event, 'local')"
    (moveToTemplateCompleted)="onMoveToSideBarCompleted()"
    (eventClicked)="onEventClicked($event)"
    (dateChanged)="onDateChange($event)"
    (eventSelected)="onSidebarEventSelected($event)"
    [setDragColors]="setDragColors.bind(this)"
    [resetDragColors]="resetDragColors.bind(this)"
    [selectedDateInput]="selectedDate"
    [tasks]="tasks"
    [filteredTasks]="filteredTasks"
    [events]="myEvents"
    [interpreter]="myResources"
    [teams]="mySortedResources"
  ></app-left-sidebar>

  <div class="calender-container">
    <div
      class="mbsc-grid mbsc-no-padding"
      [ngClass]="themeService.isDarkMode ? 'darkmode' : ''"
    >
      <div
        [class.ticket-backlog-closed]="
          !ticketBacklogOpen || (!toggleStatusBacklog && !toggleStatusTemplate)
        "
      >
        <!-- Kalender -->
        <div class="external-event-calendar" #calendarScroller>
          <mbsc-eventcalendar
            #calendar
            [data]="myEvents"
            [resources]="filterResourcesService.filteredResources"
            [showEventBuffer]="true"
            [options]="calendarOptions"
            [scheduleEventTemplate]="eventTemp"
            [showEventTooltip]="false"
            [resourceTemplate]="myResourceTemplate"
            [headerTemplate]="header"
            [resourceHeaderTemplate]="customResourceHeaderTemplate"
            [weekTemplate]="weekTemplate"
            [resourceEmptyTemplate]="customResourceEmptyTemplate"
            [(selectedEvents)]="selectedEvent"
            [zoomLevel]="zoomLevel"
            class="md-timeline-height"
            [colors]="highlightedTimes"
            displayTimezone="local"
            (onPageLoaded)="onPageLoaded($event)"
          >
            <!-- Header Template -->
            <ng-template #header>
              <app-header-template
                [openTeams]="selectedKey"
                (openTeamsChange)="handleTeamSelect($event)"
                (eventFilterChange)="handleEventFilterChange($event)"
                (teamOrderChanged)="sortInterpreters()"
                [myData]="myData"
                [(zoomLevel)]="zoomLevel"
                [stammteamData]="stammteamData"
              >
              </app-header-template>
            </ng-template>

            <!-- Resource Header Template -->
            <ng-template #customResourceHeaderTemplate>
              <div class="resource-header-container">
                <mbsc-input
                  type="text"
                  startIcon="material-search"
                  autocomplete="off"
                  class="mbsc-input"
                  inputStyle="outline"
                  placeholder="Suchen..."
                  [(ngModel)]="filterResourcesService.searchQuery"
                  (ngModelChange)="filterResourcesPopup.handleSearch()"
                  style="display: flex !important"
                />
                <mbsc-button
                  icon="material-filter-list"
                  class="filter-button"
                  (click)="openFilters()"
                  #filterButton
                ></mbsc-button>
              </div>
            </ng-template>

            <!-- Week-line Header template -->
            <ng-template #weekTemplate let-date>
              <app-week-template
                [date]="selectedDate"
                #weekTemplateComp
                [minutesHidden]="minutesHidden"
              >
              </app-week-template>
            </ng-template>

            <!-- Resource Empty Template -->
            <ng-template #customResourceEmptyTemplate>
              <div
                class="mds-resource-filtering-empty mbsc-flex mbsc-align-items-center"
              >
                <div class="mbsc-flex-1-1">
                  <p
                    class="mbsc-font mbsc-margin mbsc-medium mbsc-italic mbsc-txt-muted"
                  >
                    Keinen Mitarbeiter anhand deines Filters gefunden.
                  </p>
                  <p class="mbsc-margin mbsc-medium mbsc-italic mbsc-txt-muted">
                    Passe deinen Filter an oder benutze einen anderen
                    Suchbegriff.
                  </p>
                  <mbsc-button
                    variant="outline"
                    (click)="filterResourcesPopup.resetFilters()"
                  >
                    Filter zurücksetzen
                  </mbsc-button>
                </div>
              </div>
            </ng-template>

            <!-- Event Templates & Filter Popups -->
            <app-filter-resources-popup></app-filter-resources-popup>

            <!-- Event Content -->
            <ng-template #eventTemp let-event>
              <app-event-view
                [event]="event"
                [myResources]="myResources"
                [filteredCustomers]="filteredCustomers"
                [dragging]="dragging"
              ></app-event-view>
            </ng-template>

            <!-- Event Content -->
            <ng-template #eventTempExport let-event>
              <app-event-view-export
                [event]="event"
                [myResources]="myResources"
                [filteredCustomers]="filteredCustomers"
                [dragging]="dragging"
              ></app-event-view-export>
            </ng-template>

            <!-- Resource Template -->
            <ng-template #myResourceTemplate let-resource>
              <app-resource-template
                [resource]="resource"
                [isExporting]="isExporting"
                (fixTeam)="onFixTeam($event)"
                (unfixTeam)="onUnfixTeam($event)"
                (exportResources)="doScreenshot($event)"
                [minutesHidden]="minutesHidden"
                (unkenntlich)="toggleMinutesVisibility()"
              >
              </app-resource-template>
            </ng-template>
          </mbsc-eventcalendar>
        </div>
      </div>
    </div>
  </div>
</main>

<!-- Popups -->

<lib-event-popup
  [filteredCustomers]="filteredCustomers"
  [newlyCreatedCustomer]="newlyCreatedCustomer"
  [allCustomersData]="customersData"
  [tempEvent]="tempEvent"
  [myResources]="myResources"
  [showHistory]="showHistoryContainer"
  [showDeleteButtonContainer]="true"
  [showInterpreterSelection]="showInterpreterSelection"
  [showTabContainer]="showTabContainer"
  [selectedSegment]="selectedSegment"
  [myEvents]="myEvents"
  [invalids]="invalids"
  [inst]="inst"
  [selectedDate]="selectedDate"
  [history]="historyData"
  [stammteamData]="stammteamData"
  [isDarkMode]="isDarkMode"
  [popupCloseAfterMoveEventToBacklog]="popupCloseAfterMoveEventToBacklog"
  [popupCloseAfterEventDelete]="popupCloseAfterEventDelete"
  [popupCloseAfterEventPost]="popupCloseAfterEventPost"
  [popupCloseAfterEventUpdate]="popupCloseAfterEventUpdate"
  [travelTimeResult]="travelTimeData"
  (popupCloseAfterEventPostReset)="popupCloseAfterEventPost = false"
  (popupCloseAfterEventUpdateReset)="popupCloseAfterEventUpdate = false"
  (moveToBacklogFromChild)="moveToBacklog($event)"
  (deleteEventFromChild)="deleteEventFromLib($event)"
  (saveEventFromChild)="postEventFromLib($event)"
  (updateEventFromChild)="updateEventFromLib($event)"
  (deleteEventAfterCancel)="deleteEventAfterCancelFromLib()"
  (successToastNotification)="successToastNotification($event)"
  [travelTimeResult]="travelTimeData"
  (travelTimeRequested)="getTravelTimeWithGoogle($event)"
  (customerSearchText)="getCustomerSearchFromLib($event)"
  (updateEventHistory)="updateEventHistoryFromLib($event)"
  (requestOptions)="loadOptions()"
  (addCustomerRequested)="createCustomer($event)"
>
</lib-event-popup>

<app-event-hover
  [myResources]="myResources"
  [event]="event"
  [filteredCustomers]="filteredCustomers"
  [isPopupOpen]="isPopupOpen"
></app-event-hover>

<app-status-popup
  (moveToBacklogClicked)="moveToBacklog($event)"
  (moveToTemplateClicked)="moveToTemplate($event)"
  (processNewEvent)="processNewEvent($event.event, $event.method)"
  (processUpdateEvent)="processUpdatedEvent($event.event, $event.method)"
  (pendingUpdate)="handlePendingUpdate($event)"
  (pendingUpdateSuccess)="handleUpdateSuccess($event)"
  (updateEventData)="updateEventFromLib($event)"
  (onlyMetaChange)="onlyMetaChange = $event"
  [myEvents]="myEvents"
  [myResources]="myResources"
  [extResources]="extResources"
>
</app-status-popup>

<!-- Export-Kalender -->
<div class="export-calendar-container">
  <mbsc-eventcalendar
    #exportCalendar
    [data]="exportEvents"
    [colors]="exportColors"
    [resources]="exportResources"
    [options]="exportCalendarOptions"
    [scheduleEventTemplate]="eventTempExport"
    [resourceTemplate]="myResourceTemplate"
    [showEventTooltip]="false"
    [showEventBuffer]="false"
    displayTimezone="local"
  >
  </mbsc-eventcalendar>
</div>
